module.exports = __webpack_public_path__ + "img/geeringup.79f1f23d.jpg";